import React, { Suspense, useEffect } from "react"
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
  Redirect,
} from "react-router-dom"
import {
  dashboardLayoutRoutes,
  authLayoutRoutes,
  presentationLayoutRoutes,
  sidebarRoutes,
} from "./index"
import { useDispatch, useSelector } from "react-redux"
import DashboardLayout from "../layouts/Dashboard"
import AuthLayout from "../layouts/Auth"
import PresentationLayout from "../layouts/Presentation"
import Page404 from "../pages/auth/Page404"
import RenderOnAuthenticated from "../../src/components/keycloak/RenderOnAuthenticated"
import jwt_decode from "jwt-decode"
import UserService from "../services/UserService"
import { useHistory } from "react-router-dom"
import { addRealmRoles, userDecodeDetials } from "../reduxSagas/admin/actions"
import axios from "axios"
import _ from "lodash"
import { JSUtils } from "@utils"
import Page403 from "../pages/auth/Page403"
import AccessDenied from "../pages/auth/AccessDenied"
import ForgetPassword from "../pages/auth/ForgetPassword"
import { findFirstAllowedPath, toAppPath } from "../utils/allowedRoute"
import { usePermissionSync } from "../utils/permissionSync"

const childRoutesByJ6 = (
  Layout = () => null,
  routes = [],
  userPermAttr = {}
) => {
  const routesArray = routes.reduce((acc, x, i) => {
    const hasChildren = !_.isEmpty(x.children) && _.isArray(x.children)
    const hasComponent = !_.isEmpty(x.component)
    const isComponentIsObj = _.has(x, "component.component")
    const { isReadAllowed, isWriteAllowed, isDeleteAllowed } = JSUtils.getReadWritePermissions(
      x,
      userPermAttr
    )
    const userProfileDetails =
      useSelector((state) => state.adminReducer.userProfileDetails) || {}
    let path = _.get(x, "path")
    if (!_.isEmpty(userProfileDetails)) {
      path = `/${userProfileDetails?.roleType}${path}`
    }
    const exact = _.get(x, "exact", true)
    const Component = _.get(x, "component", () => null)
    const render = (props) => {
      if (isReadAllowed) {
        return (
          <Layout>
            <Component {...props} isWriteAllowed={isWriteAllowed} isDeleteAllowed={isDeleteAllowed} />
          </Layout>
        )
      }
      const dashboardDenied =
        _.get(x, "readAccessPath") === "Dashboard - Read" ||
        String(path).endsWith("/dashboard")
      if (dashboardDenied) {
        const nextPath = toAppPath(
          findFirstAllowedPath(sidebarRoutes, (route) =>
            JSUtils.getReadWritePermissions(route, userPermAttr).isReadAllowed
          ),
          {
            roleType: userProfileDetails?.roleType || "",
            sourceRole:
              (typeof localStorage !== "undefined" &&
                localStorage.getItem("sourceRole")) ||
              "",
            tenantId:
              (typeof localStorage !== "undefined" &&
                localStorage.getItem("tenantId")) ||
              "",
          }
        )
        const nextPathname = String(nextPath).split("?")[0]
        if (nextPath && nextPathname !== path) {
          return <Redirect to={nextPath} />
        }
      }
      const hasReadPermissionGate = Boolean(
        _.get(x, "readAccessPath") ||
          (Array.isArray(x?.childArray) &&
            x.childArray.some((child) => child?.readAccessPath))
      )
      if (hasReadPermissionGate) {
        return (
          <Layout>
            <AccessDenied />
          </Layout>
        )
      }
      return <Redirect to={{ pathname: "/403", state: { from: path } }} />
    }
    const key = `route__${path}__${i}`
    if (isComponentIsObj) {
      let childRoutesArray = childRoutesByJ6(Layout, [Component], userPermAttr)
      acc = _.concat(acc, childRoutesArray)
    }
    if (hasComponent && !isComponentIsObj) {
      acc.push(<Route key={key} path={path} exact={exact} render={render} />)
    }
    if (hasChildren) {
      let childRoutesArray = childRoutesByJ6(
        Layout,
        _.get(x, "children", []),
        userPermAttr
      )
      acc = _.concat(acc, childRoutesArray)
    }
    return acc
  }, [])
  return routesArray
}

const Routes = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const userPermAttr = useSelector(
    (state) => state.adminReducer.userKeycloakAttributes
  )
  usePermissionSync()
  return (
    <>
      {_.size(userPermAttr) > 0 && (
        <RenderOnAuthenticated>
          <Router>
            <Switch>
              {childRoutesByJ6(
                DashboardLayout,
                dashboardLayoutRoutes,
                userPermAttr
              )}
              {childRoutesByJ6(DashboardLayout, sidebarRoutes, userPermAttr)}
              {childRoutesByJ6(AuthLayout, authLayoutRoutes)}
              {childRoutesByJ6(PresentationLayout, presentationLayoutRoutes)}
              <Route
                path="/403"
                exact={true}
                render={() => (
                  <AuthLayout>
                    <Suspense fallback={<div>Loading....</div>}>
                      <Page403 />
                    </Suspense>
                  </AuthLayout>
                )}
              />
              <Route
                path="/error"
                exact={true}
                render={() => (
                  <AuthLayout>
                    <Suspense fallback={<div>Loading....</div>}>
                      <Page404 />
                    </Suspense>
                  </AuthLayout>
                )}
              />
              <Route
                path="/forgetpassword"
                exact={true}
                render={() => (
                  <AuthLayout>
                    <Suspense fallback={<div>Loading....</div>}>
                      <ForgetPassword />
                    </Suspense>
                  </AuthLayout>
                )}
              />
            </Switch>
          </Router>
        </RenderOnAuthenticated>
      )}
    </>
  )
}

export default Routes

export const LocationDisplay = () => {
  const location = useLocation()
  return <div data-testid="location-display">{location.pathname}</div>
}
